export let modulesOptions = {
  B: {
    key: 'B',
    label: 'Liczba obsługiwanych firm:',
    description:
      '<ul><li>Umożliwia obsługę księgową nawet nieograniczonej liczby firm,</li>' +
      '<li>Moduły Fakturowanie, Podatek VAT w cenie,</li>' +
      '<li>Tworzenie i wysyłka JPK_PKPIR, JPK_FA i JPK_V7M, JPK_V7K,</li>' +
      '<li>Licencja dożywotnia.</li></ul>',
  },
  P: {
    key: 'P',
    label: 'Płace i ZUS',
    description:
      '<ol>' +
      '<li>wyliczyć wynagrodzenia na podstawie różnych umów (z tytułu umów o pracę, umów zleceń, o dzieło i ryczałtowych, kontraktów menadżerskich, działalności artystycznej, praw autorskich i in.), z uwzględnieniem zwolnienia od opodatkowania osób poniżej 26 r.ż.</li>' +
      '<li>obliczyć wynagrodzenia za czas choroby i inne świadczenia (np.rehabilitacyjne, zasiłek opiekuńczy),</li>' +
      '<li>automatycznie księgować wynagrodzenia,</li>' +
      '<li>wystawiać deklarację ZUS (DRA, RMUA, RCA, RSA, RZA, RPA) i eksportować dane do programu Płatnik,</li>' +
      '<li>drukować druki ZUS (ZUS-3 i ZUS-3A, ZUS-7, ZUS Z-17),</li>' +
      '<li>drukować dokumenty – wzory: umów o pracę, o dzieło i zlecenie; rachunków do umowy o dzieło i zlecenie; zaświadczeń o zatrudnieniu; zaświadczeń o zarobkach; świadectw pracy; wypowiedzeń,</li>' +
      '<li>tworzyć deklaracje PIT-11, -4R, -8AR, IFT1/1R,</li>' +
      '<li>tworzyć listy płac i karty wynagrodzeń,</li>' +
      '<li>prowadzić kart pracy</li></ol>' +
      '<p class="text-info">Do wyboru trzy plany: obsługa do 3 osób, do 20 osób i bez limitu.</p>',
  },
};
